module.exports = __webpack_public_path__ + "static/media/AboutUs.035b1b3e.png";